import i18n from '@/plugins/i18n';
import { ContactTitle } from '@/model/Contact';

// eslint-disable-next-line import/prefer-default-export
export function contactTitleItems() {
  return [
    ContactTitle.Mr, ContactTitle.Ms, ContactTitle.Fam,
  ].map((o) => ({ text: i18n.t(`code.title.${o}`), value: o }));
}
